import axios from "axios";
import ElementUI from "element-ui";
import router from "../router";


// const baseURL = '/api';// 118 测试  
// const baseURL = "http://192.168.50.207:8210/"; // 开发  
// const baseURL = '/api';// 118 测试 
// const baseURL = "https://api.sd.wangxinban.cn/"; // 发布
// const baseURL = "http://10.5.4.19:65002/"; // 网信办
// const baseURL = "http://172.16.2.92:8102/"; // 网信办  给省委打包发这个
import { peizhi } from "./peizhi";
const service = axios.create({
  baseURL: peizhi().baseURL
});

service.interceptors.request.use(
  (config) => {
    // 一般在这个位置判断token是否存在

    // window.localStorage.setItem("baseURL", baseURL); //导入请求地址  正式
    window.localStorage.setItem("baseURL", peizhi().baseURL); //导入请求地址  测试
    const token = "Bearer " + window.localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

//响应拦截
service.interceptors.response.use(
  (response) => {
    // 处理响应数据
    if (response.data.code === 200) {
      return Promise.resolve(response);
    } else if (response.data.code === 400) {
      ElementUI.Message({
        message: response.data.msg,
        type: "warning",
      });
      router.push({
        path: "/login",
      });
    } else if (response.data.code === 500) {
      // console.log('接口500了');
      ElementUI.Message({
        message: response.data.msg,
        type: "warning",
      });
    } else if (!response.data.code) {
      // console.log("导出流信息");
      return Promise.resolve(response);
    } else {
      if (response.data.msg) {
        ElementUI.Message({
          message: response.data.msg,
          type: "error",
        });
      }

      return Promise.resolve(response);
    }
  },
  // 处理响应失败
  (error) => Promise.reject(error)
);
export default service;
